import React from 'react';
import {IntegrationEmptyCard} from '../IntegrationDesign';

export default function RsocNoIntegrationsView(props) {
    const addIntegration = () => props.history.push({pathname: '/settings/integrations/add-rsoc', state: {background: props.location}});
    return <IntegrationEmptyCard title='Revenue sync · RSOC' description='Connect a Related Search for Content provider to stream search-feed revenue.' onAdd={addIntegration}
        features={['Stream RSOC search-feed revenue.']}/>;
}
